import React from 'react';

import {
    withStyles,
    Grid,
    withRouter,
    Typography,
    ButtonBase,
} from '../../material-ui';


import MBack from '../view/MBack';
import { ChanelsItem } from './view';
import Apis from '../../network/Apis'
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';
import MSnackbar from '../view/MSnackbar';



class CustomChannel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            MyChannels: [],
            MoreChannels: [],
            isEdit: false,
        }; 

    }

    componentDidMount() {
        let { os } = this.props.match.params;

        if (os != '' && os != 0) {
            AppData.os = os
        }

        AppUtils.YMPush('MAIN', 'CustomChannel');
        this.getAllChannels();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }


    getAllChannels = async () => {
        let localChannels = AppUtils.getStorageObj(AppUtils.CUSTOM_CHANNELS);
        let result = await Apis.encryptionAllChannle();
        console.log('getAllChannels', result);
        if (result.code == 200) {
            this.setState({ MyChannels: localChannels == null ? [] : localChannels, MoreChannels: result.data });
        }
    }

    _onClickSubtraction = (item) => {
        let { MyChannels, MoreChannels } = this.state;
        for (let i = 0; i < MyChannels.length; i++) {
            if (MyChannels[i].id == item.id) {
                MyChannels.splice(i, 1);
            }
        }
        MoreChannels.push(item);
        this.setState({ MyChannels: MyChannels, MoreChannels: MoreChannels });
    }

    _onClickAdd = (item) => {
        let { MyChannels, MoreChannels } = this.state;
        MyChannels.push(item);
        for (let i = 0; i < MoreChannels.length; i++) {
            if (MoreChannels[i].id == item.id) {
                MoreChannels.splice(i, 1);
            }
        }
        this.setState({ MyChannels: MyChannels, MoreChannels: MoreChannels, isEdit: true });
    }

    _onClickComplete = () => {
        const { isEdit } = this.state;
        if (!isEdit) {
            this.setState({ isEdit: true });
        } else {
            this.getUpdateChannle();
        }
    }

    getUpdateChannle = async () => {
        AppUtils.setStorageObj(AppUtils.CUSTOM_CHANNELS, this.state.MyChannels);
        this.refs.toast.show('保存成功');
    }

    // 账号安全
    render() {
        const { classes } = this.props;
        const { MyChannels, MoreChannels, isEdit } = this.state;
        return (
            <MBack title='频道定制'>
                <Grid container direction='column' className={classes.root}>
                    <Grid style={{ width: '100%' }}>
                        <Grid container direction='row' alignItems='center' justifyContent='space-between'>
                            <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                                <Typography style={{ color: '#0D0D0D', fontWeight: 'bold', fontSize: 14, marginLeft: 8 }}>我的频道</Typography>
                                <Typography style={{ color: '#878787', fontSize: 12, marginLeft: 8 }}>长按调整顺序</Typography>
                            </Grid>
                            <Grid container justifyContent='flex-end' style={{ flex: 1 }}>
                                <ButtonBase disableRipple className={classes.buttonChip} onClick={() => this._onClickComplete()}>{isEdit ? '完成' : '编辑'}</ButtonBase>
                            </Grid>
                        </Grid>
                        <Grid container direction='row' alignItems='center' style={{ paddingRight: 8, marginTop: 8 }}>
                            {
                                MyChannels.map((item, i) => (
                                    <Grid key={i} style={{ marginLeft: 8, width: 78, marginBottom: 8 }}>
                                        <ChanelsItem add={false} del={isEdit} key={i} data={item} onClick={() => this._onClickSubtraction(item)} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                    <Grid style={{ width: '100%', marginTop: 16 }}>
                        <Grid container direction='row' alignItems='center' style={{ flex: 1 }}>
                            <Typography style={{ color: '#0D0D0D', fontWeight: 'bold', fontSize: 14, marginLeft: 8 }}>更多频道</Typography>
                            <Typography style={{ color: '#878787', fontSize: 12, marginLeft: 8 }}>
                                点击添加到我的频道
                            </Typography>
                        </Grid>
                        <Grid container direction='row' alignItems='center' style={{ paddingRight: 8, marginTop: 8 }}>
                            {
                                MoreChannels.map((item, i) => (
                                    <Grid key={i} style={{ marginLeft: 8, width: 78, marginBottom: 8 }}>
                                        <ChanelsItem add={true} del={false} key={i} data={item} onClick={() => this._onClickAdd(item)} />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                </Grid>
                <MSnackbar ref='toast' />
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        padding: theme.spacing(2, 0, 0, 0),
    },
    buttonChip: {
        backgroundColor: '#FFF',
        borderRadius: 12.5,
        minWidth: 35,
        height: 25,
        color: theme.palette.primary.main,
        padding: theme.spacing(0.5, 1.5, 0.5, 1.5),
        margin: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 11,
        border: 'solid 1px ' + theme.palette.primary.main,
    },

}))(CustomChannel));